<template>
  <div class="review-box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{detailData.afterSaleName}}</li>
          <li class="mgb15">手机号码：{{detailData.afterSaleMobile}}</li>
          <li class="mgb15" v-if="orderDetail.orderItems">商品名称：{{orderDetail.orderItems[0].productSkuName}}</li>
          <li class="mgb15">子订单号：{{detailData.orderNo}}</li>
          <li class="mgb15">下单时间：{{detailData.creationTime}}</li>
          <li v-if="detailData.afterSaleType == 3">换货地址：姓名/手机号/详细地址</li>
        </ul>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>操作说明</span>
      </div>
      <div class="text item">
        <div class="mgb15">
          <span class="mgr40">类型：{{detailData.afterSaleType == 1 ? '退款': detailData.afterSaleType == 2 ? '退货' : '换货'}}</span>
          <span>当前订单状态：
            <span v-if="orderDetail.status == 0">创建订单</span>
            <span v-if="orderDetail.status == 1">支付成功</span>
            <span v-if="orderDetail.status == 2">待发货</span>
            <span v-if="orderDetail.status == 3">已发货</span>
            <span v-if="orderDetail.status == 4">订单完成</span>
          </span>
        </div>
        <div class="mgb15">
          <span class="mgr40">需退款数量：{{detailData.afterSaleQuantity}}</span>
          <span>需退款金额：￥{{detailData.afterSaleAmount}}</span>
        </div>
        <!-- 退货 -->
        <div class="mgb15" v-if="detailData.afterSaleType == 2">
          <div class="mgb15" v-if="orderDetail.waitPurchaseQuantity">
            <span>未采购：{{orderDetail.waitPurchaseQuantity}}</span> &nbsp;&nbsp;&nbsp;
            <el-checkbox v-model="checkedWait">优先退货未采购</el-checkbox>
          </div>
          <div class="mgb15">已采购</div>
          <el-table border :data="detailData.orderAfterSaleDetails">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="供应商名称" prop="supllierName" align="center"></el-table-column>
            <el-table-column label="采购数量" align="center"></el-table-column>
            <el-table-column label="售后数量" prop="afterSaleQuantity" align="center"></el-table-column>
            <el-table-column label="发货数量" prop="exchangeShipmentQuantity" align="center"></el-table-column>
            <el-table-column label="物流单号" align="center"></el-table-column>
            <el-table-column label="退货数量" align="center"></el-table-column>
          </el-table>
          <div class="total-box">
            <span class="mgr40">退货数量合计：{{detailData.afterSaleQuantity}}</span>
            <span>退款金额合计：¥{{detailData.afterSaleAmount}}</span>
          </div>
        </div>
        <!-- 换货 -->
        <div class="mgb15" v-if="detailData.afterSaleType == 3">
          <el-table border :data="detailData.orderAfterSaleDetails">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="供应商名称" align="center"></el-table-column>
            <el-table-column label="采购数量" align="center"></el-table-column>
            <!-- <el-table-column label="售后数量" align="center"></el-table-column> -->
            <el-table-column label="发货数量" align="center"></el-table-column>
            <el-table-column label="换货数量" align="center"></el-table-column>
            <el-table-column label="" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="">
          <div class="">备注</div>
          <el-input type="textarea"></el-input>
        </div>
      </div>
    </el-card>
    <div class="btn-box">
      <el-button type="primary" @click="confirmBtn">确认</el-button>
    </div>
  </div>
</template>

<script>
import {
  OrderAfterSaleGet,
  OrderPurchaseGet,
  OrderAfterSaleUpdate
} from '../../../api/api'
export default {
  data() {
    return {
      detailData: {},
      orderDetail: {},
      orderList: [],
      id: null,
      orderId: null,
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.orderId = this.$route.query.orderid
      this.getDetail()
      this.getOrderDetail()
    }
  },
  methods: {
    confirmBtn() {
      this.$confirm("确认保存吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        let params = {};
        params.afterSaleRemark = this.remark;
        params.orderAfterSaleId = this.detailData.id;
        console.log('savbe', params)
        OrderAfterSaleConfirm(params).then(res => {
          console.log('---', res);
          if (res.data.success) {
            this.$message.success(res.data.msg || '保存成功');
          } else {
            this.$message.error(res.data.error.message || '保存失败, 请重试');
          }
        });
      }).catch(() => {
      });
    },
    getDetail() {
      OrderAfterSaleGet({id: this.id}).then(res => {
        if (res.data.success) {
          this.detailData = res.data.result || {}
        }
      })
    },
    getOrderDetail() {
      OrderPurchaseGet({id: this.orderId}).then(res => {
        if (res.data.success) {
          this.orderDetail = res.data.result || {}
          // this.orderList = res.data.result.orderPurchases || []
          let orderLogistics = res.data.result.orderLogistics || []
          // if (orderLogistics[0]) {
          //   this.orderDetail.forEach(item => {
          //     item.logisticsNo = orderLogistics.filter(val => {
          //       return val.orderId == item.orderId
          //     }).map(v => {
          //       return v.logisticsNo
          //     }).join(',')
          //   })
          // } 
          // this.orderList.forEach(item => {
          //   item.supllierId = null
          //   item.supllierName = null
          //   item.logisticsNo = orderLogistics.filter(val => {
          //     return val.orderId == item.orderId
          //   }).map(v => {
          //     return v.logisticsNo
          //   }).join(',')
          //   // item.isReplaceSupllier = true
          //   // item.afterSaleQuantity = null
          // })
          // console.log(this.orderList,'?????')
        }
      })
    },
  }
}
</script>

<style scoped>
.review-box{
  padding: 0 20px;
}
.box-card{
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: 700;
}
.mgb15{
  margin-bottom: 15px;
}
.mgr40{
  margin-right: 40px;
}
.total-box{
  margin-top: 15px;
  text-align: right;
}
.btn-box{
  text-align: center;
  margin-top: 20px;
}
</style>
